exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".breadcrumbs{font-size:24px;font-weight:600;line-height:40px;display:flex;flex-direction:row;flex-wrap:wrap;align-items:center}.breadcrumbs.breadcrumbs--gray-wrapper{background:#f3f4f6;padding:15px 20px;height:70px}.breadcrumbs .breadcrumbs__crumb,.breadcrumbs .breadcrumbs__divider{color:#565e76}.breadcrumbs .breadcrumbs__crumb:last-of-type{color:#333847}.breadcrumbs .k-icon.k-icon-next{font-size:24px;margin:0 3px}", ""]);

// exports
